import { render, staticRenderFns } from "./NewComplaint.vue?vue&type=template&id=6b7d6b34"
import script from "./NewComplaint.vue?vue&type=script&lang=js"
export * from "./NewComplaint.vue?vue&type=script&lang=js"
import style0 from "./NewComplaint.vue?vue&type=style&index=0&id=6b7d6b34&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports